var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHindi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hindi",
    transform: "translate(21301 -2570)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21301 2570)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8148",
    "data-name": "Path 8148",
    d: "M-20446.1,2324.828h20.766l2.48,4.529h-6.238v37.088l-5.215-2.991V2348.5a21.042,21.042,0,0,1-5.625.261,13.888,13.888,0,0,1-4.7-1.568s4.1,11.681-9.629,13.12c-10.6.229-17.062-15.062-17.062-15.062l2.348-1.818s2.9,7.412,8.012,10.688c2.529,1.621,6.154,2.09,8.8.354,3.854-2.528,4.012-6.2,3.031-8.647a7.11,7.11,0,0,0-3.031-3.4l-7.008,2.478s-3.766-2.917-3.766-4.434,3.766-1.633,3.766-1.633,3.729.5,6.154-1.867c1.385-1.352,2.475-5.132,1.361-6.885-1.059-1.666-3.117-2.186-5.289-1.828a22.49,22.49,0,0,0-7.525,3.317l-2.732-4.529s8.506-6.191,15.975,0c2.764,2.291,4.723,5.342,4.783,7.631.1,3.656-3.326,6.042-3.326,6.042s3.547,3.348,7.414,3.689,8.053-2.322,8.053-2.322v-12.733h-9.143Z",
    transform: "translate(-809.408 272.155)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHindi);
export default __webpack_public_path__ + "static/media/Hindi.74e32d9b.svg";
export { ForwardRef as ReactComponent };